import React, { useState } from 'react';
import { Card, Form, Input, Button, Modal } from 'antd';
import api from '../api';

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [notificationModal, setNotificationModal] = useState({
    isOpen: false,
    title: '',
    content: '',
  });

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      setNotificationModal({ isOpen: true, title: 'Lỗi', content: 'Mật khẩu xác nhận không khớp!' });
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/auth/change-password', {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });

      if (response.data.status === true) {
        setNotificationModal({ isOpen: true, title: 'Thành công', content: 'Đổi mật khẩu thành công!' });
        form.resetFields();
      } else {
        setNotificationModal({ isOpen: true, title: 'Lỗi', content: response.data.message || 'Có lỗi xảy ra.' });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Lỗi server, vui lòng thử lại.';
      setNotificationModal({ isOpen: true, title: 'Lỗi', content: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card title="Đổi mật khẩu">
        <Form
          form={form}
          name="change_password"
          onFinish={onFinish}
          layout="vertical"
          style={{ maxWidth: 400, margin: 'auto' }}
        >
          <Form.Item
            name="oldPassword"
            label="Mật khẩu cũ"
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu cũ!' }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="Mật khẩu mới"
            rules={[
              { required: true, message: 'Vui lòng nhập mật khẩu mới!' },
              { min: 6, message: 'Mật khẩu phải có ít nhất 6 ký tự.' }
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Xác nhận mật khẩu mới"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Vui lòng xác nhận mật khẩu mới!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Hai mật khẩu bạn đã nhập không khớp!'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Lưu thay đổi
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <Modal
        open={notificationModal.isOpen}
        title={notificationModal.title}
        onOk={() => setNotificationModal({ isOpen: false, title: '', content: '' })}
        onCancel={() => setNotificationModal({ isOpen: false, title: '', content: '' })}
        footer={[
          <Button key="ok" type="primary" onClick={() => setNotificationModal({ isOpen: false, title: '', content: '' })}>
            Đã hiểu
          </Button>,
        ]}
      >
        <p>{notificationModal.content}</p>
      </Modal>
    </>
  );
};

export default ChangePassword; 